export default class KeyValuePair {
  key: string
  value: string
  disabled?: boolean

  constructor (key: string, value: string, disabled?: boolean) {
    this.key = key
    this.value = value
    this.disabled = disabled
  }
}
